import { Controller } from "@hotwired/stimulus"

const EXPANDED_ACTIVE = [
  "bg-vivid-purple/5",
  "border-l-vivid-purple",
  "border-b",
  "border-b-vivid-purple/15",
]
const MINI_ACTIVE = ["ring-2", "ring-vivid-purple"]
const OVERVIEW_ACTIVE = ["bg-vivid-purple/5", "border-l-vivid-purple"]

export default class extends Controller {
  static targets = ["card", "overview"]
  static values = { selected: String }

  connect() {
    if (this.hasSelectedValue && this.selectedValue) {
      this.highlight(this.selectedValue)
    } else {
      this.#activateOverview()
    }

    this._handleKeydown = (e) => this.#onKeydown(e)
    window.addEventListener("keydown", this._handleKeydown)
  }

  // Clicking the pinned Overview entry: deselect every track, activate Overview.
  selectOverview() {
    this.cardTargets.forEach((card) => this.#deactivate(card))
    this.#activateOverview()
  }

  disconnect() {
    window.removeEventListener("keydown", this._handleKeydown)
  }

  select(event) {
    const trackId = event.params.trackId || event.currentTarget.dataset.trackId
    this.highlight(trackId)
  }

  highlight(trackId) {
    const id = String(trackId)
    this.#deactivateOverview()
    this.cardTargets.forEach((card) => {
      if (card.dataset.trackCardId === id) {
        this.#activate(card)
      } else {
        this.#deactivate(card)
      }
    })
  }

  #activateOverview() {
    if (!this.hasOverviewTarget) return
    this.overviewTarget.classList.remove("border-l-transparent")
    this.overviewTarget.classList.add(...OVERVIEW_ACTIVE)
  }

  #deactivateOverview() {
    if (!this.hasOverviewTarget) return
    this.overviewTarget.classList.remove(...OVERVIEW_ACTIVE)
    this.overviewTarget.classList.add("border-l-transparent")
  }

  #isMini(card) {
    return card.dataset.adminTrackSelectMini === "true"
  }

  #activate(card) {
    const classes = this.#isMini(card) ? MINI_ACTIVE : EXPANDED_ACTIVE
    card.classList.add(...classes)
  }

  #deactivate(card) {
    card.classList.remove(...EXPANDED_ACTIVE, ...MINI_ACTIVE)
  }

  #activeCard() {
    return this.cardTargets.find(
      (c) =>
        c.classList.contains(EXPANDED_ACTIVE[0]) ||
        c.classList.contains(MINI_ACTIVE[0]),
    )
  }

  #onKeydown(event) {
    if (event.key !== "ArrowUp" && event.key !== "ArrowDown") return

    const tag = document.activeElement?.tagName
    if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT") return
    if (document.activeElement?.isContentEditable) return

    event.preventDefault()

    const active = this.#activeCard()
    const cards = this.cardTargets
    if (cards.length === 0) return

    const currentIndex = active ? cards.indexOf(active) : -1
    const nextIndex =
      event.key === "ArrowUp"
        ? currentIndex <= 0
          ? 0
          : currentIndex - 1
        : currentIndex < 0
          ? 0
          : Math.min(currentIndex + 1, cards.length - 1)

    const nextCard = cards[nextIndex]
    if (!nextCard || nextCard === active) return

    const link = nextCard.querySelector("a[data-turbo-frame]")
    if (link) {
      this.highlight(nextCard.dataset.trackCardId)
      link.click()
      nextCard.scrollIntoView({ block: "nearest", behavior: "smooth" })
    }
  }
}
